/* eslint-disable */
export default [
  {
    url: "/home",
    name: "Ana Sayfa",
    slug: "home",
    icon: "HomeIcon",
    i18n: "home"
  },
  {
    url: "/categories",
    name: "Kategoriler",
    slug: "categories",
    icon: "GridIcon",
    i18n: "categories"
  },
  {
    url: "/products",
    name: "Ürünler",
    slug: "products",
    icon: "ImageIcon",
    i18n: "products",
    submenu: [
      {
        url: "/products",
        name: "Ürünler",
        slug: "products",
        i18n: "products"
      },
      {
        url: "/products/add",
        name: "Ürün Ekle",
        slug: "products/add",
        i18n: "addProduct"
      }
    ]
  },
  
  {
    url: "/properties",
    name: "Özellikler",
    slug: "properties",
    icon: "FeatherIcon",
    i18n: "properties"
  },
  {
    url: "/share",
    name: "Share",
    slug: "share",
    icon: "Share2Icon",
    i18n: "sharing",
    submenu: [
      {
        url: "/share",
        name: "Share",
        slug: "share",
        i18n: "sharing"
      },
      {
        url: "/catalog",
        name: "Catalog",
        slug: "catalog",
        i18n: "catalog"
      },
      {
        url: "/createvideo",
        name: "Create Video",
        slug: "createvideo",
        i18n: "generateVideo"
      }
    ]
  },
  {
    url: "/companyInfo",
    name: "Company Info",
    slug: "companyInfo",
    icon: "SettingsIcon",
    i18n: "companyInfo"
  },
];
